import React from 'react';

interface IconProps {
  name: string;
  size?: number;
  color?: string;
  style?: React.CSSProperties;
}

/**
 * Wrapper leve para ícones "Material Symbols Rounded" (variante filled),
 * usado nas páginas do fluxo do participante. Fonte carregada via Google
 * Fonts em public/index.html — ver frontend/src/theme/participantTheme.ts.
 */
export const Icon: React.FC<IconProps> = ({ name, size = 22, color, style }) => (
  <span
    className="material-symbols-rounded"
    style={{
      fontSize: size,
      color,
      lineHeight: 1,
      fontVariationSettings: "'FILL' 1",
      userSelect: 'none',
      ...style,
    }}
  >
    {name}
  </span>
);
